import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const editDocumentTooltip = 'Edit file';
export const deleteDocumentTooltip = 'Delete file';
export const downloadDocumentTooltip = 'Download file';
export const descriptionDocumentTooltip = 'View full description';
export const addDocumentTooltip = 'Upload new file';
export const addDocumentText = 'Upload new';
export const emptyText = 'No documents available';

export const descriptionModalTitle = 'View description';

export const deleteModalQuestion = 'Are you sure you want to delete the file?';

export const MAX_DOCUMENTS_COUNT = 10;
export const MAX_DESCRIPTION_ROW_TEXT_LENGTH = 230;

export const EAttachedDocumentsColumnsAccessors = {
	file: 'file',
	size: 'size',
	uploaded: 'uploaded',
	description: 'description',
	actions: 'actions',
} as const;

export type TAttachedDocumentsColumnsAccessors = TValueOfStringRecord<typeof EAttachedDocumentsColumnsAccessors>

export const modalWidth = '580px';
